import * as yup from 'yup';
import { CURRENCY_WITH_CENTS } from '../../../utils/validate';

export const newBudgetAllocationSchema = yup.object().shape({
  netCashReward: yup
    .string()
    .matches(CURRENCY_WITH_CENTS, 'Cash Reward value should be in digits format XX.XX only')
    .test(
      'is-greater-than-zero',
      'Cash Reward should be greater than 0',
      (value) => value && +value > 0
    )
    .required('Cash Reward is a required field'),
  weAre8Fee: yup
    .string()
    .matches(CURRENCY_WITH_CENTS, 'WeAre8 fee value should be in digits format XX.XX only')
    .test(
      'is-greater-than-zero',
      'WeAre8 fee should be greater than 0',
      (value) => value && +value > 0
    )
    .required('WeAre8 fee is a required field'),
  charityDonation: yup
    .string()
    .matches(CURRENCY_WITH_CENTS, 'Charity donation value should be in digits format XX.XX only')
    .test(
      'is-greater-than-zero',
      'Charity donation should be greater than 0',
      (value) => value && +value > 0
    )
    .required('Charity donation is a required field'),
});
